<template>
    <v-card
        class="dashboard-card ma-2"
        elevation="4"
    >
        <v-card-title>Management Case Administrator</v-card-title>
        <v-card-subtitle>number of patients, by days ago</v-card-subtitle>

        <!--#region--=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-NEW-PATIENTS-REGISTERED--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">New Patients Registered</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsVerified: false,
                                patientAgedDaysMax: 1,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-1</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.new.group1 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsVerified: false,
                                patientAgedDaysMin: 2,
                                patientAgedDaysMax: 2,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">2</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.new.group2 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsVerified: false,
                                patientAgedDaysMin: 3,
                                patientAgedDaysMax: 3,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">3</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.new.group3 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsVerified: false,
                                patientAgedDaysMin: 4,
                                patientAgedDaysMax: 4,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">4</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.new.group4 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsVerified: false,
                                patientAgedDaysMin: 5,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">5+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.new.group5_Plus }}</h3>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        <!--#region--=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-VERIFIED--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Verified Patients</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsVerified: true,
                                patientAgedDaysMax: 5,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-5</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.verified.group0_5 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsVerified: true,
                                patientAgedDaysMin: 6,
                                patientAgedDaysMax: 10,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">6-10</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.verified.group6_10 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsVerified: true,
                                patientAgedDaysMin: 11,
                                patientAgedDaysMax: 15,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">11-15</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.verified.group11_15 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsVerified: true,
                                patientAgedDaysMin: 16,
                                patientAgedDaysMax: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">16-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.verified.group16_30 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsVerified: true,
                                patientAgedDaysMin: 31,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">31+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.verified.group31_Plus }}</h3>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        <!--#region--=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-SUSPENDED--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Suspended Patients</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsSuspended: true,
                                patientAgedDaysMax: 5,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-5</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.suspended.group0_5 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsSuspended: true,
                                patientAgedDaysMin: 6,
                                patientAgedDaysMax: 10,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">6-10</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.suspended.group6_10 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsSuspended: true,
                                patientAgedDaysMin: 11,
                                patientAgedDaysMax: 15,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">11-15</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.suspended.group11_15 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsSuspended: true,
                                patientAgedDaysMin: 16,
                                patientAgedDaysMax: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">16-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.suspended.group16_30 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsSuspended: true,
                                patientAgedDaysMin: 31,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">31+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.suspended.group31_Plus }}</h3>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        <!--#region--=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-PATIENT-ADMITTED-INTO-HOSPITAL--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <!--<v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Patients Admitted Into Hospital</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsAdmitted: true,
                                patientAgedDaysMax: 1,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-1</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.admitted.group1 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsAdmitted: true,
                                patientAgedDaysMin: 2,
                                patientAgedDaysMax: 2,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">2</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.admitted.group2 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsAdmitted: true,
                                patientAgedDaysMin: 3,
                                patientAgedDaysMax: 3,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">3</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.admitted.group3 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsAdmitted: true,
                                patientAgedDaysMin: 4,
                                patientAgedDaysMax: 4,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">4</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.admitted.group4 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsAdmitted: true,
                                patientAgedDaysMin: 5,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">5+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.admitted.group5_Plus }}</h3>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>-->
        <!--#endregion-->
        <!--#region--=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-FRAUDULENT--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Fraudulent Patients</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsFraudulent: true,
                                patientAgedDaysMax: 5,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">0-5</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.fraudulent.group0_5 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsFraudulent: true,
                                patientAgedDaysMin: 6,
                                patientAgedDaysMax: 10,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">6-10</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.fraudulent.group6_10 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsFraudulent: true,
                                patientAgedDaysMin: 11,
                                patientAgedDaysMax: 15,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">11-15</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.fraudulent.group11_15 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsFraudulent: true,
                                patientAgedDaysMin: 16,
                                patientAgedDaysMax: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">16-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.fraudulent.group16_30 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsFraudulent: true,
                                patientAgedDaysMin: 31,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">31+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.fraudulent.group31_Plus }}</h3>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        <!--#region--=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-FINALISED--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Finalised Patients</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsFinalised: true,
                                patientAgedDaysMax: 5,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">0-5</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.finalised.group0_5 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsFinalised: true,
                                patientAgedDaysMin: 6,
                                patientAgedDaysMax: 10,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">6-10</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.finalised.group6_10 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsFinalised: true,
                                patientAgedDaysMin: 11,
                                patientAgedDaysMax: 15,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">11-15</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.finalised.group11_15 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsFinalised: true,
                                patientAgedDaysMin: 16,
                                patientAgedDaysMax: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">16-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.finalised.group16_30 }}</h3>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Patients',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                mcaIsFinalised: true,
                                patientAgedDaysMin: 31,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">31+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.finalised.group31_Plus }}</h3>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        <!--#region--=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-FOOTER--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <v-row justify="end">
                <v-col
                    align-self="center"
                    cols="12"
                    md="6"
                >
                    <h5
                        class="text--secondary"
                        style="text-align: right"
                    >
                        Auto updates every
                        {{ (refreshSeconds / 60000).toString().substr(0, 4) }} minutes
                        or
                        <v-btn
                            @click="getData"
                            class="ml-1 white--text"
                            color="secondary darken-1"
                            elevation="4"
                            fab
                            x-small
                        >
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </h5>
                </v-col>
            </v-row>
        </v-card-text>
        <!--#endregion-->
    </v-card>
</template>

<script>
export default {
    name: "ManagementCaseAdministratorWidget",
    props: {
        selectedAreaProviderFilter: {
            type: Object,
            default: () => {
                return { areaId: 0, providerId: 0 };
            }
        }
    },
    data: () => ({
        dataObject: null,
        refreshTimeout: null,
        refreshSeconds: 300000,
        storeDispatch: "incidents/getmanagementcaseadministratorwidget",
        providerId: 0,
        areaId: 0,
        //
    }),
    mounted: function() {
        this.refreshTimeout = setTimeout(this.getData, 0);
    },
    computed: {
        //
    },
    watch: {
        selectedAreaProviderFilter: function() {
            this.providerId = this.selectedAreaProviderFilter.providerId;
            this.areaId = this.selectedAreaProviderFilter.areaId;
            this.getData();
        }
    },
    methods: {
        getData() {
            this.stopRefreshTimeOut();
            this.dataObject = null;

            this.$store
                .dispatch(this.storeDispatch, {
                    urlParameters: {
                        providerId: this.selectedAreaProviderFilter.providerId,
                        areaId: this.selectedAreaProviderFilter.areaId
                    }
                })
                .then(dataResponse => {
                    this.dataObject = dataResponse;
                })
                .finally(() => {
                    this.refreshTimeout = setTimeout(
                        this.getData,
                        this.refreshSeconds
                    );
                });
        },
        stopRefreshTimeOut() {
            if (this.refreshTimeout != null) clearTimeout(this.refreshTimeout);
        }
        //--------------------
    },
    destroyed: function() {
        this.stopRefreshTimeOut();
    }
};
</script>

<style lang="stylus" scoped>
span {
    .facevalue {
        font-size: 0.54rem;
    }
}

#app.theme--light {
    span.facevalue {
        color: black !important;
    }
}

#app.theme--dark {
    span.facevalue {
        color: white !important;
    }
}
</style>